import IndexNavbar from 'components/Navbars/IndexNavbar'
import React from 'react'
import { Row, Col, Container } from "reactstrap"

const PrivacyPolicy = () => {

    return (
        <>
            <IndexNavbar />
            <Container >
                <section className='privacy-section'>
                    <Row className='d-flex justify-content-center align-items-center'>
                       
                        <Col lg="12">
                            <h2 className='text-dark text-center'>Privacy Policy</h2>
                            <p className='text-dark'>Last Updated: 20 March 2025</p>
                            <p className='text-dark'>Welcome to AdsAI, a digital signage application. Your privacy is important to us. This Privacy Policy explains how we handle data when you use our application.</p>
                        </Col>
                        <Col lg="12">
                            <h4 className='text-dark mb-1 mt-3'>1. No Personal Data Collection</h4>
                            <p className='text-dark'>AdsAI does not collect, store, or process any personal information from users. Our application is designed to be a plug-and-play solution, requiring only minimal configuration to function.</p>
                        </Col>
                        <Col lg="12">
                            <h4 className='text-dark mb-1 mt-3'>2. How AdsAI Works</h4>
                            <ul style={{ paddingLeft: "15px" }}>
                                <li className='text-dark'>Users install the application and configure basic settings.</li>
                                <li className='text-dark'>AdsAI fetches advertisements directly from our servers.</li>
                                <li className='text-dark'>No user data, personal information, or browsing activity is collected or stored.</li>
                            </ul>
                        </Col>
                        <Col lg="12">
                            <h4 className='text-dark mb-1 mt-3'>3. Cookies and Tracking Technologies</h4>
                            <p className='text-dark'>AdsAI does not use cookies, trackers, or any other means of collecting user data.</p>
                        </Col>
                        <Col lg="12">
                            <h4 className='text-dark mb-1 mt-3'>4. Data Security</h4>
                            <p className='text-dark'>Since we do not collect any user data, there is no risk of personal information being accessed, altered, or disclosed. Our app communicates with our servers securely to fetch advertisements.</p>
                        </Col>
                        <Col lg="12">
                            <h4 className='text-dark mb-1 mt-3'>5. Third-Party Links</h4>
                            <p className='text-dark'>AdsAI may display advertisements from third-party sources, but we do not track or collect any data related to user interactions with these ads. Users are encouraged to review the privacy policies of any third-party services they interact with.</p>
                        </Col>
                        <Col lg="12">
                            <h4 className='text-dark mb-1 mt-3'>6. Updates to This Privacy Policy</h4>
                            <p className='text-dark'>We may update this Privacy Policy from time to time. Any changes will be reflected with a new "Last Updated" date, and we encourage you to review this page periodically.</p>
                        </Col>
                        <Col lg="12">
                            <h4 className='text-dark mb-1 mt-3'>7. Contact Us</h4>
                            <p className='text-dark'>If you have any questions about this Privacy Policy, you can contact us at:</p>
                        </Col>
                        <Col lg="12">
                            <h4 className='text-dark mb-1 mt-3'>AdsAI Support</h4>
                            <p className='text-dark'><a href="/#contact">Contact Us</a></p>
                            <p className='text-dark'><strong>Website:</strong> <span>https://adsai.tech/</span></p>
                        </Col>
                    </Row>
                </section>
            </Container >
            <div>

                <Row className="d-flex justify-content-center align-items-center border-footer pt-3 pb-3 foot-text mt-5 mb-1" >
                    <Col lg="3" md="3" >

                    </Col>
                    <Col md="6" lg="6" className=" text-center  text-uppercase">
                        <p className="mb-0">© Copyright {new Date().getFullYear()} ADS AI All rights reserved.</p>
                    </Col>
                    <Col lg="3" md="3" >

                    </Col>

                </Row>

            </div>
        </>
    )
}

export default PrivacyPolicy